import React, { Fragment, useState } from "react";

import ActionButton from "../Buttons/ActionButton";
import DropdownButton from "../Buttons/DropdownButton";
import DropdownItem from "../DropdownItem";
import NotificationsButton from "../NotificationsButton";
import { NavLink } from "react-router-dom";

import { ReactComponent as MenuIcon } from "../../assets/icons/menu.svg";
import { ReactComponent as NotificationsIcon } from "../../assets/icons/notifications.svg";
import { ReactComponent as AccountIcon } from "../../assets/icons/account_circle.svg";
import { ReactComponent as TabletIcon } from "../../assets/icons/tablet.svg";

import Logo from "../../assets/images/boogie_logo.png";
import PowerIoTLogo from "../../assets/images/logo.png";

import MobileMenu from "../MobileMenu";
import { useAuth } from "../../context/AuthContext";
import { useUser } from "../../Api/newSockets.api";
import { useKioskMode } from "../../context/KioskModeContext";
import { useModuleAccess } from "../../hooks/useModuleAccess";

export default function AppBar() {
  const { logout } = useAuth();
  const { user } = useUser();
  const { enableKioskMode } = useKioskMode();
  const { landingPath } = useModuleAccess();
  const [menu, setMenu] = useState(false);

  const clickHandler = (e: React.MouseEvent) => {
    setMenu(!menu);
    e.preventDefault();
  };

  const handleLogout = logout || (() => localStorage.removeItem("user"));

  // Get user name from socket data or localStorage fallback
  const userName = user?.fullname || user?.email || "User";

  return (
    <div className="app-bar">
      <div
        onClick={clickHandler}
        className={`menu-button ${menu ? "open" : ""}`}
      >
        <ActionButton icon={<MenuIcon />} className="app-bar-action" />
      </div>
      {menu && <MobileMenu onClick={clickHandler} />}
      <div className="title">
        <div className="logo">
          <NavLink to={landingPath} className="nav-link">
            <img className="logo-img logo-boogie" src={Logo} alt="Logo" />
            <img className="logo-img logo-poweriot" src={PowerIoTLogo} alt="PowerIoT Logo" />
          </NavLink>
        </div>
      </div>
      <div className="user-actions">
        <div onClick={enableKioskMode} title="Enter Kiosk Mode">
          <ActionButton icon={<TabletIcon />} className="app-bar-action" />
        </div>
        <NotificationsButton
          icon={<NotificationsIcon />}
          className="app-bar-action"
        />
        <DropdownButton icon={<AccountIcon />} className="app-bar-action">
          <Fragment>
            <DropdownItem
              icon={<AccountIcon />}
              label={userName}
              to="/profile"
              bottomBorder={true}
            />
            <DropdownItem label="Profile" to="/profile" />
            <DropdownItem
              label="Log out"
              to="/login"
              onClick={handleLogout}
            />
          </Fragment>
        </DropdownButton>
      </div>
    </div>
  );
}
